// extracted by mini-css-extract-plugin
module.exports = {"statusCard":"SongStatuses_statusCard__2JjW0","statusAdditionalCard":"SongStatuses_statusAdditionalCard__3ECsR"};